import Colors from 'constants/Colors';

export default {
  contentWrapper: {
    padding: '2rem',
    borderRadius: '1rem',
  },

  infoText: {
    marginBottom: '2rem',
    color: Colors.darkText,
  },

  checkinFields: {
    border: '1px solid #000',
    borderRadius: '1rem',
    padding: '1.5rem',
    backgroundColor: '#fff',
    marginBottom: '2rem',
  },

  fieldLabel: {
    display: 'block',
    marginBottom: '0.5rem',
    fontWeight: 'bold',
    color: Colors.darkText,
  },

  checkboxContainer: {
    border: '1px solid #000',
    borderRadius: '1rem',
    padding: '1.5rem',
    backgroundColor: '#fff',
    marginBottom: '2rem',
  },

  checkboxItem: {
    marginBottom: '1rem',
    color: Colors.darkText,
  },

  checkboxLabel: {
    marginLeft: '0.5rem',
    fontWeight: 'normal',
  },

  viewLink: {
    fontWeight: 'bold',
  },

  disabledButton: {
    backgroundColor: '#ccc',
    color: '#fff',
    textAlign: 'center',
    borderRadius: '2rem',
    padding: '1rem',
    fontWeight: 'bold',
    cursor: 'not-allowed',
  },

  container: {
    backgroundColor: 'var(--color-content-box-bg)',
    borderRadius: 18,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    padding: '2rem',
  },

  header: {
    display: 'flex',
    color: 'var(--color-header-text)',
    fontSize: 16,
    padding: '4px 20px',
    justifyContent: 'space-between',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    marginBottom: '1rem',
  },

  paperlessOuterWrapper: {
    padding: 16,
    borderRadius: 16,
    minHeight: '100vh',
  },

  paperlessHeaderContainer: {
    position: 'relative',
    padding: '12px 8px',
    marginBottom: 16,
    height: 120,
  },

  paperlessBackButton: {
    position: 'absolute',
    top: 16,
    left: 16,
    padding: '6px 14px',
    fontSize: 14,
    fontWeight: 'bold',
    border: '1px solid #000',
    borderRadius: '1rem',
    backgroundColor: '#fff',
    color: '#000',
  },

  paperlessLogoBox: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: 80,
    height: 80,
    border: `2px solid ${Colors.darkText}`,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    backgroundColor: '#fff',
  },

  paperlessLogoImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },

  paperlessTitleBar: {
    backgroundColor: '#000',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: 20,
    textAlign: 'center',
    padding: 12,
    borderRadius: 8,
    marginBottom: 20,
  },

  paperlessInfoBoxContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    marginBottom: 16,
  },

  paperlessInfoBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flex: '1 1 30%',
    padding: 16,
    backgroundColor: '#fff',
    borderRadius: 8,
  },

  paperlessIcon: {
    fontSize: 24,
  },

  paperlessInfoLabel: {
    fontSize: 12,
    color: '#666',
  },

  paperlessSectionTitle: {
    fontWeight: 'bold',
    fontSize: 18,
    textAlign: 'center',
    margin: '20px 0 12px 0',
  },

  paperlessAdultCard: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
    backgroundColor: '#fff',
    borderRadius: 8,
  },

  paperlessStatusBadge: {
    backgroundColor: '#fde6c4',
    color: '#a55d00',
    padding: '4px 10px',
    borderRadius: 12,
    fontSize: 12,
    fontWeight: 'bold',
  },

  paperlessCheckinButton: {
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    padding: '8px 16px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },

  chainWrapper: {
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 32,
    boxSizing: 'border-box',
    position: 'relative',
  },

  chainLanguageSelector: {
    position: 'absolute',
    top: 16,
    right: 32,
  },

  chainLogoContainer: {
    marginBottom: 32,
  },

  chainLogoBox: {
    width: 80,
    height: 80,
    border: `2px solid ${Colors.darkText}`,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    backgroundColor: '#fff',
  },

  chainLogoImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },

  chainLogoPlaceholder: {
    fontSize: 24,
  },

  chainTitle: {
    marginBottom: 24,
  },

  chainHotelBox: {
    backgroundColor: '#fff',
    borderRadius: 20,
    padding: 24,
    minWidth: '90%',
    boxShadow: '0px 0px 12px rgba(0, 0, 0, 0.1)',
    marginBottom: 32,
  },

  chainHotelLabel: {
    fontSize: 14,
  },

  chainHotelSelect: {
    marginTop: 8,
    width: '100%',
    padding: 12,
    fontSize: 16,
    backgroundColor: Colors.white,
    boxShadow: 'none',
    outline: 'none',
    border: '1px solid #ccc',
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
  },

  chainContinueButton: {
    fontWeight: 'bold',
    padding: '12px 48px',
    border: 'none',
    borderRadius: 32,
    fontSize: 18,
    cursor: 'pointer',
    width: '60%',
  },
};
